import { mutator } from 'satcheljs';
import getStore from '../store/store';
import setBookingPageSetupStatus from '../actions/setBookingPageSetupStatus';

/**
 * updates anonymous sharing flag in store and enables personal booking button flight
 */
export default mutator(setBookingPageSetupStatus, actionMessage => {
    const store = getStore();
    store.isAnonymousSharingEnabled = actionMessage.hasPersonalBookingSetUp;
    store.owaCalendarBookingButtonEnabled = true; // ensures that the flight only gets enabled after the personal booking status is set
});
